import { render, staticRenderFns } from "./quantitativeReport.vue?vue&type=template&id=6a7224fa&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./quantitativeReport.vue?vue&type=style&index=0&id=6a7224fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7224fa",
  null
  
)

export default component.exports